const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgP001(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 322.9103,
    y1: 211.2298,
    x2: 314.6871,
    y2: 50.8795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC0B5",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    points: "397.66,237.838 240.22,147.283 240.831,41.71 398.272,132.267  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF56A9"
    },
    points: "337.343,146.798 319.183,150.163 301.028,153.514 301.152,132.327 301.274,111.135  319.305,128.969  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129203963468940110150000002000353548549306046_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.722,
    y1: 59.821,
    x2: 207.0843,
    y2: 164.1485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC0B5",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129203963468940110150000002000353548549306046_)"
    },
    d: "M218.247,74.647l-55.779-32.204 c-1.3-0.75-2.35-0.146-2.354,1.342l-0.119,41.782c-0.004,1.487,1.04,3.301,2.339,4.052l41.703,24.077l14.564,20.109 l-3.629-13.796l3.142,1.813c1.295,0.749,2.35,0.146,2.355-1.341l0.118-41.782C220.59,77.211,219.542,75.396,218.247,74.647z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF56A9"
    },
    points: "214.443,102.938 214.439,104.74 166.089,76.826 166.094,75.024  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF56A9"
    },
    points: "214.51,79.69 214.504,81.486 166.155,53.572 166.161,51.776  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF56A9"
    },
    points: "214.422,110.692 214.416,112.488 166.067,84.573 166.072,82.777  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF56A9"
    },
    points: "214.466,95.191 214.46,96.987 166.111,69.072 166.117,67.277  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF56A9"
    },
    points: "214.487,87.444 214.482,89.24 166.134,61.325 166.139,59.529  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035499281013972355390000014745525134871554968_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.2549,
    y1: 137.4794,
    x2: 189.6307,
    y2: 25.5349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC0B5",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035499281013972355390000014745525134871554968_)"
    },
    d: "M222.413,76.699l0.009-0.005 c-0.018-0.076-0.041-0.151-0.063-0.227c-0.008-0.025-0.014-0.052-0.021-0.077c-0.005-0.017-0.008-0.033-0.014-0.049 l-0.004,0.002c-0.294-0.923-0.879-1.827-1.592-2.434l0.006-0.003c-0.017-0.014-0.034-0.026-0.051-0.039 c-0.02-0.017-0.041-0.032-0.063-0.049c-0.052-0.041-0.104-0.085-0.158-0.123l-0.01,0.006c-0.088-0.063-0.174-0.131-0.264-0.183 L164.41,41.314c-0.652-0.377-1.243-0.412-1.669-0.164c-0.647,0.376-1.295,0.752-1.942,1.129c0.426-0.248,1.017-0.213,1.67,0.164 l55.779,32.204c0.145,0.084,0.287,0.186,0.425,0.295c0.025,0.021,0.051,0.039,0.076,0.06c0.742,0.615,1.352,1.558,1.647,2.514 c0.008,0.028,0.015,0.055,0.022,0.083c0.108,0.373,0.17,0.746,0.17,1.101l-0.118,41.782c-0.002,0.739-0.264,1.26-0.686,1.504 c0.647-0.376,1.295-0.751,1.942-1.128c0.421-0.246,0.683-0.766,0.685-1.505l0.118-41.782 C222.529,77.289,222.482,76.994,222.413,76.699z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087405201794773440880000012400647420636649652_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.3395,
    y1: 136.1734,
    x2: 211.7152,
    y2: 24.2274
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC0B5",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000087405201794773440880000012400647420636649652_)"
    },
    points: "214.972,120.01  218.602,133.806 220.544,132.677 217.652,121.567  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150075137275458695570000013798703486720400531_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.392,
    y1: 162.9263,
    x2: 398.9661,
    y2: 69.0467
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC0B5",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150075137275458695570000013798703486720400531_)"
    },
    d: "M419.353,112.978 C419.353,112.977,419.353,112.977,419.353,112.978v-0.001c-0.008-0.079-0.021-0.17-0.04-0.287 c-0.02-0.102-0.045-0.203-0.076-0.304c-0.184-0.609-0.554-1.21-1.009-1.637l0,0c-0.151-0.142-0.313-0.264-0.48-0.361 l-33.588-19.392c-0.056-0.032-0.111-0.061-0.165-0.085c-0.054-0.025-0.108-0.047-0.161-0.065 c-0.104-0.036-0.205-0.058-0.302-0.067l-0.002-0.001h-0.003c-0.096-0.009-0.188-0.005-0.273,0.012 c-0.324,0.064-0.566,0.305-0.667,0.693l-0.001,0.002v0.001c-0.034,0.129-0.052,0.275-0.053,0.436l-0.109,38.587 c-0.001,0.341,0.079,0.707,0.26,1.165c0.055,0.128,0.117,0.255,0.241,0.474c0.066,0.109,0.136,0.216,0.211,0.318 c0.043,0.058,0.088,0.115,0.134,0.17c0.137,0.165,0.287,0.316,0.445,0.445c0.053,0.042,0.106,0.083,0.16,0.121 c0.055,0.038,0.11,0.073,0.165,0.105l33.588,19.393c0.306,0.176,0.588,0.236,0.833,0.207l0.072-0.003l0.177-0.065 c0.001-0.001,0.003-0.001,0.005-0.002l0.059-0.022l0.151-0.122c0.056-0.054,0.104-0.118,0.147-0.19l0.052-0.079l0.096-0.295 c0.022-0.108,0.034-0.227,0.034-0.355l0.109-38.587C419.363,113.121,419.36,113.056,419.353,112.978z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF56A9"
    },
    d: "M406.472,113.146c3.235,1.868,8.918,10.723,3.539,15.48c-4.251,3.762-8.906,5.057-9.151,5.125 c-0.244-0.35-4.877-7.008-9.093-15.658c-5.336-10.944,0.38-13.217,3.615-11.349c0.061,0.036,0.123,0.073,0.183,0.113 c2.809,1.81,4.885,6.536,5.349,7.665c0.469-0.591,2.565-2.908,5.375-1.474C406.349,113.077,406.409,113.11,406.472,113.146z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176027153467483973560000014274097803190892979_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.4741,
    y1: 205.6326,
    x2: 424.5735,
    y2: 153.5505
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC0B5",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176027153467483973560000014274097803190892979_)"
    },
    d: "M435.883,177.922L435.883,177.922 L435.883,177.922c-0.004-0.044-0.011-0.095-0.022-0.16c-0.011-0.057-0.025-0.113-0.042-0.169 c-0.102-0.338-0.308-0.671-0.56-0.908l0,0c-0.084-0.079-0.173-0.146-0.266-0.2l-18.634-10.758 c-0.031-0.018-0.061-0.034-0.092-0.048c-0.03-0.014-0.06-0.026-0.089-0.036c-0.058-0.02-0.114-0.032-0.167-0.037h-0.001h-0.001 c-0.053-0.005-0.104-0.003-0.151,0.006c-0.18,0.036-0.314,0.17-0.37,0.385l0,0.001v0c-0.019,0.072-0.029,0.152-0.029,0.242 l-0.061,21.408c0,0.189,0.044,0.392,0.144,0.646c0.03,0.071,0.065,0.142,0.134,0.263c0.036,0.061,0.075,0.12,0.117,0.176 c0.023,0.033,0.048,0.064,0.074,0.095c0.076,0.092,0.16,0.175,0.247,0.247c0.03,0.023,0.059,0.046,0.089,0.067 c0.031,0.021,0.062,0.04,0.092,0.058l18.634,10.759c0.169,0.097,0.327,0.13,0.463,0.114l0.04-0.002l0.098-0.036 c0.001-0.001,0.002-0.001,0.003-0.001l0.033-0.012l0.084-0.067c0.031-0.03,0.058-0.066,0.082-0.105l0.029-0.044l0.053-0.163 c0.012-0.06,0.019-0.126,0.019-0.197l0.06-21.407C435.889,178.002,435.887,177.966,435.883,177.922z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF56A9"
    },
    d: "M428.738,178.016c1.795,1.036,4.948,5.948,1.963,8.587c-2.358,2.087-4.941,2.806-5.077,2.843 c-0.136-0.194-2.706-3.888-5.044-8.687c-2.96-6.071,0.211-7.332,2.005-6.296c0.034,0.02,0.068,0.041,0.102,0.063 c1.558,1.003,2.711,3.626,2.968,4.252c0.26-0.328,1.423-1.613,2.982-0.817C428.669,177.978,428.703,177.996,428.738,178.016z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF56A9"
    },
    d: "M206.644,149.822L206.644,149.822L206.644,149.822c-0.006-0.068-0.017-0.148-0.035-0.249 c-0.015-0.089-0.04-0.177-0.064-0.264c-0.16-0.528-0.482-1.049-0.876-1.419l0,0c-0.131-0.123-0.271-0.229-0.415-0.313 l-29.116-16.81c-0.049-0.028-0.096-0.052-0.143-0.075c-0.046-0.022-0.093-0.041-0.141-0.056c-0.089-0.031-0.177-0.05-0.26-0.058 h-0.002h-0.003c-0.082-0.008-0.162-0.005-0.235,0.01c-0.282,0.056-0.49,0.266-0.579,0.602v0.001v0.001 c-0.029,0.112-0.046,0.238-0.046,0.377l-0.095,33.449c0,0.295,0.069,0.613,0.226,1.009c0.045,0.112,0.101,0.222,0.208,0.412 c0.058,0.095,0.117,0.188,0.183,0.275c0.037,0.051,0.077,0.101,0.116,0.148c0.119,0.144,0.251,0.274,0.384,0.386 c0.048,0.036,0.094,0.072,0.141,0.105c0.047,0.033,0.095,0.063,0.143,0.09l29.115,16.811c0.265,0.152,0.512,0.204,0.723,0.179 l0.063-0.003l0.153-0.057c0,0,0.002,0,0.002-0.001l0.052-0.02l0.131-0.105c0.049-0.047,0.09-0.103,0.128-0.165l0.044-0.07 l0.084-0.255c0.019-0.094,0.027-0.197,0.029-0.308l0.093-33.448C206.653,149.947,206.65,149.891,206.644,149.822z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "194.365,161.346 199.085,164.072 189.819,170.705 180.618,153.41 185.338,156.135  185.378,142.203 194.404,147.414  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F4F95"
    },
    d: "M160.644,166.155L160.644,166.155L160.644,166.155c-0.006-0.068-0.018-0.148-0.035-0.249 c-0.016-0.089-0.041-0.177-0.064-0.264c-0.16-0.528-0.482-1.049-0.877-1.419l0,0c-0.131-0.124-0.271-0.229-0.414-0.313 l-29.117-16.809c-0.049-0.028-0.096-0.052-0.143-0.075c-0.046-0.022-0.093-0.041-0.141-0.056c-0.089-0.031-0.177-0.05-0.26-0.058 h-0.002h-0.003c-0.082-0.008-0.162-0.005-0.235,0.01c-0.282,0.056-0.49,0.266-0.579,0.602v0.002v0.001 c-0.029,0.112-0.046,0.238-0.046,0.377l-0.095,33.449c0,0.295,0.069,0.613,0.226,1.009c0.045,0.112,0.101,0.222,0.208,0.412 c0.058,0.095,0.117,0.188,0.183,0.275c0.037,0.051,0.077,0.101,0.116,0.148c0.119,0.144,0.25,0.274,0.384,0.386 c0.048,0.036,0.094,0.072,0.141,0.104c0.047,0.033,0.095,0.064,0.143,0.09l29.115,16.811c0.264,0.152,0.512,0.204,0.723,0.179 l0.063-0.003l0.154-0.057c0,0,0.002,0,0.002-0.001l0.051-0.02l0.133-0.105c0.049-0.047,0.09-0.103,0.127-0.164l0.045-0.07 l0.084-0.255c0.018-0.094,0.027-0.197,0.029-0.308l0.092-33.448C160.652,166.28,160.65,166.224,160.644,166.155z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "143.884,159.536 153.085,176.833 148.364,174.108 148.325,188.038 139.298,182.827  139.338,168.896 134.617,166.17  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058547443702964633340000014380888363035804593_",
    gradientUnits: "userSpaceOnUse",
    x1: 617.9263,
    y1: 390.9001,
    x2: 638.9771,
    y2: 260.0215,
    gradientTransform: "matrix(-1.08 0.5102 0.3823 0.9287 669.5729 -312.1684)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB5E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF98B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058547443702964633340000014380888363035804593_)"
    },
    d: "M94.832,276.34 c9.955,6.973,17.353,2.716,22.336,5.502c4.984,2.785,10.952,7.961,14.889,17.523c7.874,19.125,2.91,28.576,13.678,34.657 c10.768,6.082,22.524,11.696,25.354,20.004c2.831,8.308,5.599,13.599,5.599,13.599s-5.063-3.699-25.655-2.093 c-20.591,1.606-35.374-5.625-38.296-18.458c-2.922-12.834-0.636-23.051-14.255-30.324c-13.619-7.272-27.722-30.053-24.91-38.997 C76.384,268.81,84.878,269.368,94.832,276.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE77B3"
    },
    d: "M171.771,363.141c-7.243-7.118-18.408-7.387-27.152-11.941 c-9.431-4.912-14.958-12.605-18.824-22.258c-3.127-7.807-3.47-16.32-8.667-23.251c-2.258-3.011-5.595-4.789-8.984-6.206 c-5.568-2.328-10.261-4.305-14.485-8.777c-0.285-0.302-0.675-0.296-0.998-0.065c-0.568,0.405-0.662,0.448-0.754,1.088 c-0.076,0.521,0.75,0.825,0.998,0.343c-1.102,2.135,6.595,6.282,7.699,6.863c4.717,2.483,9.84,3.715,13.608,7.721 c3.427,3.643,4.665,8.898,5.885,13.585c1.12,4.298,2.393,8.432,3.913,12.601c3.027,8.297,9.18,14.922,16.547,19.589 c9.26,5.866,20.47,6.768,30.027,12.056C171.427,364.952,172.552,363.909,171.771,363.141z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034810669490183582240000000888433393152902312_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.7064,
    y1: 282.569,
    x2: 205.2436,
    y2: 282.569,
    gradientTransform: "matrix(0.993 0.1178 -0.1178 0.993 35.4407 -17.0603)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB5E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF98B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034810669490183582240000000888433393152902312_)"
    },
    d: "M200.114,239.008 c-3.52,13.872-4.789,15.77,4.068,29.659c8.855,13.889-7.626,44.61-13.359,58.518c-5.734,13.908-4.807,35.608-4.807,35.608 s-17.751-22.528-26.13-40.444c-8.379-17.916,9.615-36.788,7.254-46.404c-2.36-9.617-12.348-9.05-11.451-26.45 c0.896-17.398,10.386-28.527,18.383-36.914C182.069,204.191,208.88,204.453,200.114,239.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE77B3"
    },
    d: "M185.508,357.317c-3.204-11.406-5.825-21.649-4.528-33.634 c1.279-11.817,3.675-23.268,1.744-35.168c-3.111-19.172-10.896-41.954,3.721-58.455c0.385-0.435-0.29-1.088-0.722-0.708 c-16.058,14.133-9.642,37.881-6.288,56.106c2.472,13.433,0.026,26.023-1.403,39.395c-1.169,10.943,0.417,23.494,6.391,32.935 C184.743,358.29,185.672,357.9,185.508,357.317z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010992605831653434160000014360668913843827625_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.5676,
    y1: 335.9098,
    x2: 144.3493,
    y2: 191.1422,
    gradientTransform: "matrix(0.9979 0.0654 -0.0654 0.9979 20.3719 -8.7088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F0A1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF97B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010992605831653434160000014360668913843827625_)"
    },
    d: "M122.046,207.349 c8.754-4.397,24.848-0.856,24.876,17.165c0.027,18.022-8.131,31.779-2.117,41.494c6.015,9.715,18.902,6.832,24.347,25.209 c5.446,18.377-0.844,58.976-0.844,58.976s-16.271-37.728-33.407-43.823c-17.136-6.095-35.926-25.16-34.807-50.128 C101.4,227.121,113.293,211.745,122.046,207.349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB75CA"
    },
    d: "M160.588,309.624c-5.91-9.267-14.979-15.68-23.097-22.713c-8.339-7.226-14.27-15.6-15.667-26.945 c-1.188-9.636-0.339-23.703,5.936-31.465c0.397-0.491-0.331-1.056-0.772-0.7c-6.984,5.623-7.621,17.358-7.97,25.717 c-0.397,9.555,2.109,18.494,7.602,26.187c6.729,9.425,17.088,15.547,25.082,23.712c10.274,10.496,13.54,23.88,15.398,38.157 c0.08,0.607,0.939,0.609,1.123,0.074C171.677,331.598,165.905,317.962,160.588,309.624z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128450907110343639960000000440110607482989699_",
    gradientUnits: "userSpaceOnUse",
    x1: -647.35,
    y1: 321.229,
    x2: -639.0419,
    y2: 439.8092,
    gradientTransform: "matrix(-1 0 0 1 -338.3544 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC0B5",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000128450907110343639960000000440110607482989699_)"
    },
    points: "345.536,280.842  345.536,389.949 267.846,434.159 267.352,325.343  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "251.081,226.221 345.536,280.842 267.352,325.343 172.902,270.713  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183948025827097019450000001471420201592588692_",
    gradientUnits: "userSpaceOnUse",
    x1: -558.037,
    y1: 333.4701,
    x2: -560.5137,
    y2: 439.9718,
    gradientTransform: "matrix(-1 0 0 1 -338.3544 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC0B5",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000183948025827097019450000001471420201592588692_)"
    },
    points: "172.902,379.817  172.902,270.713 267.352,325.343 267.846,434.159  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016756164101398642670000006681706013450066085_",
    gradientUnits: "userSpaceOnUse",
    x1: -471.6914,
    y1: 351.9858,
    x2: -471.6914,
    y2: 446.1371,
    gradientTransform: "matrix(-1 0 0 1 -338.3544 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC0B5",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000016756164101398642670000006681706013450066085_)"
    },
    points: "148.403,341.649  148.403,415.763 118.559,433.116 118.271,359.173  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "113.214,321.267 148.403,341.649 118.271,359.173 83.084,338.786  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004521875090244357030000000166138232113488266_",
    gradientUnits: "userSpaceOnUse",
    x1: -439.1754,
    y1: 351.9858,
    x2: -439.1754,
    y2: 446.1371,
    gradientTransform: "matrix(-1 0 0 1 -338.3544 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC0B5",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000004521875090244357030000000166138232113488266_)"
    },
    points: "83.084,412.897 83.084,338.786  118.271,359.173 118.559,433.116  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2C0"
    },
    d: "M228.327,206.572c0.315,5.041,1.499,15.288,1.89,19.22c-2.216,4.564-7.142,9.719-11.82,14.308 c-0.817,0.331-8.84,2.704-11.618,4.688c-3.799,2.712-5.742,9.014-4.21,12.168c2.653,5.458,7.461,2.989,9.247-0.241 c2.082-3.768,7.012-4.886,7.012-4.886s-4.508,4.561-3.286,6.31c1.222,1.749,6.378-0.852,7.821-4.249 c1.444-3.397,0.85-5.917,0.85-5.917s24.432-17.66,25.157-22.003c0.724-4.344-6.858-21.973-6.858-21.973L228.327,206.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434D88"
    },
    d: "M263.615,132.686c0,0,11.816-1.418,15.597,20.323c3.781,21.74,2.835,21.268,8.034,27.884 c5.199,6.617,7.562,14.652,1.418,20.323c-6.144,5.671-15.597,3.309-25.994-1.418c-10.398-4.726-15.597-2.363-25.049-4.726 c-9.452-2.363-14.65-1.418-12.288-14.179c2.363-12.76,11.816-13.233,10.398-19.85S239.039,129.378,263.615,132.686z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC3990"
    },
    d: "M186.578,359.859c0,0-7.119,7.406-10.398,9.768c-3.277,2.361-5.546,4.947-4.265,7.439 c1.282,2.494,5.02,4.918,14.526,0c9.827-5.08,11.794-6.809,12.424-9.645c0.63-2.836,0.37-6.57-1.891-8.507 C194.771,357.023,186.578,359.859,186.578,359.859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F4F95"
    },
    d: "M229.272,251.471c0,0-47.262,30.72-47.262,42.063c0,11.343,1.891,60.968,2.363,65.222 c0.472,4.253,4.727,8.035,10.398,6.144c5.671-1.891,5.199-1.417,6.144-4.253c0.945-2.836,3.781-46.789,5.199-52.461 c1.418-5.671,19.85-14.178,34.502-21.74c14.651-7.562,25.048-17.487,22.685-29.775 C260.937,244.382,229.272,251.471,229.272,251.471z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC3990"
    },
    d: "M211.627,374.51c0,0-7.119,7.407-10.397,9.768c-3.276,2.361-5.546,4.948-4.265,7.439 c1.283,2.494,5.021,4.918,14.526,0c9.828-5.079,11.794-6.809,12.425-9.645c0.63-2.836,0.369-6.57-1.891-8.507 C219.819,371.674,211.627,374.51,211.627,374.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F4F95"
    },
    d: "M254.32,266.122c0,0-47.261,30.72-47.261,42.063c0,11.343,1.89,60.968,2.362,65.221 c0.473,4.254,4.727,8.035,10.398,6.145c5.671-1.891,5.199-1.419,6.144-4.254c0.945-2.835,3.781-46.789,5.199-52.46 c1.417-5.671,19.85-14.178,34.5-21.74c14.651-7.562,25.049-17.486,22.686-29.774C285.986,259.033,254.32,266.122,254.32,266.122z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC3990"
    },
    d: "M249.02,186.975c-2.398-2.148-7.814-4.014-15.314,3.676c-6.989,7.157-7.742,17.811-6.797,24.9 c0.4,3,14.255,2.549,16.166,2.649C244.985,218.302,251.417,189.124,249.02,186.975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC3990"
    },
    d: "M263.126,280.597c-21.257-1.648-37.894-16.191-39.998-21.091 c5.199-7.563,14.375-13.344,13.928-16.696c-0.446-3.352-0.91-10.97-2.758-14.729c-3.958-8.053-3.276-16.781,1.195-24.156 c2.502-4.129,2.605-10.213,3.498-12.717c2.29-6.433,8.272-7.287,15.285-7.215c7.013,0.07,14.34,3.421,24.148,12.182 c7.948,7.093,5.082,20.097,4.411,26.466c-0.67,6.369-2.048,15.912-0.63,22.056c1.417,6.144,3.781,10.083,4.726,17.645 c0.655,5.244,2.836,13.706-2.836,17.014C280.332,281.551,272.968,281.359,263.126,280.597z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CECECE"
    },
    d: "M273.353,276.385c0.295,0.172,0.297,0.447,0.004,0.617l-32.285,18.762 c-0.294,0.171-0.77,0.171-1.065,0l-52.024-30.036c-0.295-0.17-0.296-0.446-0.003-0.616l32.285-18.762 c0.293-0.171,0.77-0.171,1.064,0L273.353,276.385z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000099659345036055130220000002760584909214017437_",
    style: {
      enableBackground: "new"
    },
    d: " M187.762,265.418c-0.003,0.525-0.003,1.051-0.005,1.578c0,0.111,0.073,0.224,0.222,0.31l0.005-1.578 C187.835,265.643,187.761,265.53,187.762,265.418z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103964601296850070560000006869098695691543715_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099659345036055130220000002760584909214017437_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000103964601296850070560000006869098695691543715_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4A4A4"
    },
    d: "M187.762,265.418l-0.005,1.578c0,0.016,0.002,0.031,0.005,0.047l0.004-1.578 C187.762,265.45,187.762,265.434,187.762,265.418"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADADAD"
    },
    d: "M187.766,265.465l-0.004,1.578c0.006,0.037,0.021,0.073,0.043,0.106l0.004-1.577 C187.788,265.538,187.772,265.501,187.766,265.465"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4B4B4"
    },
    d: "M187.809,265.572l-0.004,1.577c0.033,0.051,0.081,0.099,0.147,0.141l0.004-1.578 C187.892,265.67,187.843,265.622,187.809,265.572"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCBCBC"
    },
    d: "M187.957,265.712l-0.004,1.578c0.008,0.005,0.018,0.01,0.026,0.015l0.005-1.578 C187.974,265.722,187.966,265.718,187.957,265.712"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000012441159358510168020000003084666503554887862_",
    style: {
      enableBackground: "new"
    },
    d: " M273.571,278.273c0.001-0.526,0.003-1.052,0.005-1.578c0,0.11-0.073,0.222-0.219,0.306l-0.004,1.578 C273.499,278.495,273.571,278.384,273.571,278.273z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097500595143674300830000007811096239134631598_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000012441159358510168020000003084666503554887862_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000097500595143674300830000007811096239134631598_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9C9C"
    },
    d: "M273.357,277.002l-0.004,1.578c0.146-0.085,0.218-0.195,0.219-0.306l0.005-1.578 C273.576,276.806,273.503,276.918,273.357,277.002"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9A9A9A"
    },
    points: "241.072,295.764 241.067,297.341 273.353,278.58 273.357,277.002  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C0C0C0"
    },
    points: "187.983,265.728 187.979,267.305 240.003,297.341 240.007,295.764  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000165922812660156334770000005663345083051766685_",
    style: {
      enableBackground: "new"
    },
    d: " M240.007,295.764l-0.004,1.578c0.295,0.171,0.772,0.171,1.064,0l0.005-1.578 C240.778,295.935,240.303,295.935,240.007,295.764z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086684523371211110910000018412417994990705854_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165922812660156334770000005663345083051766685_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000086684523371211110910000018412417994990705854_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCBCBC"
    },
    d: "M240.007,295.764l-0.004,1.578c0.053,0.031,0.111,0.056,0.173,0.075l0.005-1.578 C240.119,295.819,240.06,295.794,240.007,295.764"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4B4B4"
    },
    d: "M240.181,295.839l-0.005,1.578c0.085,0.026,0.178,0.042,0.271,0.05l0.004-1.577 C240.357,295.882,240.266,295.865,240.181,295.839"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADADAD"
    },
    d: "M240.451,295.889l-0.004,1.577c0.063,0.005,0.127,0.004,0.19-0.001l0.005-1.578 C240.578,295.892,240.514,295.893,240.451,295.889"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4A4A4"
    },
    d: "M240.642,295.888l-0.005,1.578c0.063-0.005,0.125-0.014,0.185-0.029l0.004-1.578 C240.767,295.872,240.704,295.883,240.642,295.888"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9C9C"
    },
    d: "M240.826,295.859l-0.004,1.578c0.09-0.021,0.173-0.053,0.246-0.095l0.005-1.578 C240.999,295.806,240.916,295.837,240.826,295.859"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7A7A7"
    },
    d: "M234.478,257.831c-0.363-0.21-0.952-0.21-1.313,0l-7.938,4.615 c-0.362,0.21-0.361,0.549,0.003,0.76l18.226,10.522c0.363,0.21,0.951,0.21,1.312,0l7.939-4.614 c0.36-0.208,0.359-0.55-0.005-0.759L234.478,257.831z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M210.077,258.287c-0.293-0.17-0.771-0.17-1.064,0l-1.591,0.924 c-0.293,0.171-0.291,0.447,0.003,0.617l1.602,0.925c0.294,0.171,0.771,0.171,1.064,0l1.591-0.925 c0.293-0.169,0.292-0.445-0.002-0.616L210.077,258.287z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M213.508,260.267c-0.294-0.171-0.771-0.169-1.063,0.001l-1.591,0.924 c-0.294,0.17-0.293,0.446,0.003,0.617l1.602,0.924c0.295,0.17,0.771,0.17,1.064,0l1.591-0.924 c0.293-0.171,0.292-0.447-0.003-0.617L213.508,260.267z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M216.939,262.247c-0.295-0.17-0.771-0.17-1.065,0l-1.591,0.925 c-0.293,0.171-0.292,0.446,0.002,0.617l1.603,0.924c0.294,0.17,0.77,0.17,1.064,0l1.591-0.924 c0.293-0.171,0.292-0.447-0.002-0.617L216.939,262.247z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M212.226,263.757c-0.296-0.171-0.772-0.171-1.065,0l-1.591,0.924 c-0.293,0.171-0.292,0.447,0.002,0.617l1.603,0.924c0.296,0.171,0.771,0.171,1.065,0l1.59-0.924 c0.294-0.17,0.293-0.446-0.003-0.617L212.226,263.757z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M202.775,262.531c-0.295-0.17-0.771-0.171-1.064,0l-1.592,0.924 c-0.293,0.17-0.29,0.447,0.003,0.617l3.976,2.295c0.294,0.17,0.771,0.17,1.064,0l1.592-0.925 c0.292-0.169,0.291-0.445-0.004-0.616L202.775,262.531z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M220.37,264.228c-0.294-0.17-0.772-0.169-1.065,0.001l-1.591,0.925 c-0.294,0.171-0.292,0.446,0.003,0.616l1.603,0.925c0.294,0.17,0.771,0.17,1.064,0l1.591-0.924 c0.294-0.17,0.292-0.446-0.003-0.617L220.37,264.228z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M215.652,265.736c-0.295-0.171-0.772-0.171-1.064,0l-1.592,0.924 c-0.294,0.171-0.292,0.446,0.003,0.617l1.602,0.925c0.294,0.17,0.771,0.17,1.065,0l1.591-0.925 c0.292-0.171,0.292-0.445-0.004-0.617L215.652,265.736z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M208.573,265.879c-0.295-0.171-0.771-0.171-1.064,0l-1.593,0.924 c-0.292,0.17-0.291,0.447,0.004,0.617l1.602,0.925c0.295,0.17,0.772,0.17,1.065,0l1.591-0.925 c0.293-0.17,0.292-0.446-0.004-0.617L208.573,265.879z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M199.123,264.653c-0.295-0.17-0.771-0.17-1.064,0l-1.593,0.924 c-0.293,0.17-0.29,0.446,0.005,0.616l4.661,2.692c0.294,0.17,0.771,0.17,1.064,0l1.593-0.925 c0.292-0.17,0.292-0.447-0.003-0.617L199.123,264.653z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M219.077,267.713c-0.294-0.171-0.77-0.171-1.064,0l-1.59,0.925 c-0.294,0.17-0.292,0.446,0.002,0.616l1.602,0.925c0.294,0.169,0.77,0.169,1.064-0.001l1.591-0.924 c0.292-0.171,0.291-0.447-0.003-0.616L219.077,267.713z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M212,267.857c-0.295-0.17-0.772-0.17-1.064,0l-1.591,0.925 c-0.293,0.17-0.292,0.446,0.003,0.617l1.602,0.925c0.295,0.17,0.771,0.17,1.065,0l1.591-0.925 c0.292-0.17,0.292-0.447-0.004-0.617L212,267.857z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M227.232,268.19c-0.295-0.169-0.771-0.169-1.065,0l-1.591,0.924 c-0.292,0.171-0.291,0.447,0.004,0.618l1.602,0.924c0.295,0.171,0.771,0.171,1.064,0l1.592-0.924 c0.292-0.17,0.291-0.447-0.003-0.618L227.232,268.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M205.697,268.448c-0.295-0.17-0.772-0.17-1.064,0l-1.593,0.925 c-0.292,0.17-0.29,0.446,0.006,0.616l1.601,0.924c0.294,0.171,0.771,0.171,1.064,0.001l1.591-0.926 c0.292-0.169,0.292-0.446-0.003-0.616L205.697,268.448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M222.504,269.692c-0.296-0.171-0.771-0.171-1.065,0l-1.591,0.924 c-0.292,0.17-0.29,0.446,0.004,0.618l1.601,0.924c0.295,0.17,0.771,0.17,1.065,0.001l1.591-0.925 c0.293-0.171,0.292-0.447-0.003-0.618L222.504,269.692z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M215.425,269.835c-0.294-0.17-0.77-0.17-1.064,0l-1.591,0.926 c-0.292,0.169-0.291,0.446,0.003,0.616l1.602,0.925c0.294,0.17,0.772,0.17,1.064,0l1.592-0.925 c0.293-0.17,0.291-0.446-0.003-0.616L215.425,269.835z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M230.663,270.172c-0.296-0.171-0.772-0.171-1.065,0l-1.591,0.923 c-0.294,0.17-0.292,0.446,0.003,0.617l1.602,0.924c0.294,0.171,0.771,0.171,1.065,0l1.591-0.924 c0.293-0.171,0.292-0.447-0.003-0.617L230.663,270.172z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M209.212,270.478c-0.295-0.17-0.772-0.17-1.066,0l-1.591,0.924 c-0.293,0.17-0.291,0.446,0.004,0.616l1.602,0.925c0.295,0.17,0.772,0.17,1.065,0l1.591-0.925 c0.293-0.17,0.292-0.446-0.003-0.616L209.212,270.478z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M218.853,271.814c-0.295-0.17-0.772-0.17-1.064,0l-1.592,0.925 c-0.292,0.17-0.29,0.446,0.004,0.617l1.602,0.925c0.295,0.17,0.771,0.17,1.064,0l1.592-0.925 c0.293-0.17,0.292-0.446-0.003-0.617L218.853,271.814z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M234.093,272.151c-0.295-0.171-0.773-0.169-1.065,0l-1.591,0.925 c-0.293,0.171-0.292,0.446,0.003,0.617l1.602,0.924c0.295,0.17,0.772,0.17,1.065,0l1.591-0.924 c0.292-0.17,0.292-0.447-0.003-0.617L234.093,272.151z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M229.357,273.647c-0.294-0.17-0.771-0.17-1.064,0.001l-1.591,0.925 c-0.292,0.17-0.292,0.446,0.003,0.616l1.602,0.924c0.295,0.171,0.771,0.171,1.064,0l1.591-0.924 c0.293-0.17,0.292-0.447-0.003-0.616L229.357,273.647z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M222.279,273.792c-0.294-0.171-0.771-0.171-1.065,0l-1.591,0.925 c-0.294,0.17-0.293,0.446,0.003,0.616l1.602,0.924c0.295,0.171,0.772,0.171,1.064,0l1.592-0.924 c0.294-0.171,0.292-0.446-0.003-0.616L222.279,273.792z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M237.523,274.132c-0.295-0.17-0.772-0.169-1.065,0l-1.59,0.925 c-0.294,0.17-0.291,0.446,0.003,0.617l1.602,0.925c0.295,0.17,0.772,0.17,1.064,0l1.592-0.925 c0.292-0.17,0.292-0.446-0.004-0.617L237.523,274.132z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M232.783,275.626c-0.295-0.17-0.772-0.17-1.064,0l-1.592,0.925 c-0.292,0.17-0.29,0.446,0.004,0.617l1.602,0.924c0.295,0.171,0.771,0.171,1.064,0l1.591-0.924 c0.294-0.171,0.293-0.447-0.003-0.617L232.783,275.626z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M225.705,275.77c-0.295-0.17-0.771-0.17-1.064,0l-1.592,0.925 c-0.292,0.17-0.292,0.446,0.003,0.616l1.602,0.924c0.295,0.17,0.772,0.17,1.065,0l1.591-0.924 c0.294-0.171,0.292-0.447-0.002-0.616L225.705,275.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M240.954,276.113c-0.294-0.17-0.772-0.169-1.064,0l-1.592,0.925 c-0.292,0.17-0.292,0.445,0.004,0.616l1.601,0.925c0.295,0.171,0.771,0.171,1.065,0l1.591-0.925 c0.294-0.169,0.292-0.446-0.003-0.616L240.954,276.113z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M244.385,278.094c-0.296-0.17-0.773-0.17-1.065,0l-1.591,0.925 c-0.294,0.171-0.292,0.447,0.003,0.616l1.602,0.924c0.296,0.171,0.772,0.171,1.064,0l1.592-0.924 c0.293-0.169,0.292-0.445-0.003-0.616L244.385,278.094z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M236.21,277.604c-0.295-0.17-0.771-0.17-1.064,0l-1.592,0.925 c-0.294,0.17-0.292,0.445,0.003,0.617l1.601,0.924c0.296,0.171,0.772,0.171,1.066,0l1.591-0.924 c0.293-0.171,0.292-0.447-0.004-0.617L236.21,277.604z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M239.635,279.582c-0.295-0.169-0.77-0.169-1.064,0.001l-1.591,0.925 c-0.294,0.171-0.292,0.446,0.003,0.617l1.602,0.924c0.295,0.17,0.771,0.171,1.065,0l1.591-0.923 c0.293-0.171,0.291-0.448-0.004-0.618L239.635,279.582z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M247.816,280.074c-0.295-0.17-0.772-0.17-1.064,0l-1.592,0.925 c-0.293,0.17-0.291,0.447,0.004,0.617l1.602,0.925c0.294,0.169,0.772,0.169,1.064,0l1.591-0.925 c0.293-0.17,0.292-0.447-0.003-0.617L247.816,280.074z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M243.062,281.56c-0.295-0.17-0.773-0.17-1.064,0l-1.591,0.925 c-0.294,0.17-0.292,0.446,0.002,0.617l1.603,0.925c0.294,0.17,0.771,0.17,1.064,0l1.591-0.925 c0.294-0.17,0.292-0.447-0.003-0.617L243.062,281.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M235.983,281.705c-0.294-0.171-0.771-0.171-1.064,0l-1.591,0.924 c-0.292,0.17-0.292,0.446,0.002,0.617l1.603,0.925c0.294,0.17,0.772,0.17,1.065,0l1.591-0.925 c0.292-0.171,0.29-0.447-0.004-0.617L235.983,281.705z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M251.247,282.055c-0.295-0.171-0.772-0.171-1.065,0l-1.592,0.925 c-0.293,0.17-0.292,0.446,0.004,0.617l1.601,0.925c0.295,0.17,0.771,0.17,1.065,0l1.591-0.925 c0.292-0.17,0.292-0.447-0.003-0.617L251.247,282.055z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M232.156,283.725c-0.295-0.17-0.773-0.17-1.065,0l-1.591,0.925 c-0.293,0.17-0.292,0.446,0.004,0.616l1.601,0.924c0.295,0.171,0.771,0.171,1.064,0l1.592-0.925 c0.292-0.17,0.292-0.446-0.004-0.616L232.156,283.725z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M246.489,283.539c-0.296-0.171-0.772-0.171-1.065,0l-1.591,0.924 c-0.293,0.17-0.292,0.446,0.004,0.617l2.708,1.563c0.295,0.169,0.771,0.169,1.064,0l1.59-0.925 c0.293-0.171,0.292-0.447-0.003-0.618L246.489,283.539z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M235.67,285.754c-0.294-0.17-0.77-0.17-1.064,0l-1.591,0.925 c-0.293,0.17-0.291,0.446,0.003,0.616l1.603,0.926c0.294,0.17,0.771,0.17,1.063,0l1.591-0.926 c0.293-0.169,0.292-0.445-0.003-0.616L235.67,285.754z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M242.837,285.661c-0.295-0.17-0.771-0.17-1.065,0l-1.591,0.925 c-0.292,0.17-0.292,0.446,0.004,0.617l2.708,1.563c0.295,0.17,0.772,0.17,1.064,0l1.591-0.924 c0.294-0.172,0.292-0.447-0.003-0.617L242.837,285.661z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M239.186,287.783c-0.296-0.171-0.772-0.17-1.065,0l-1.592,0.924 c-0.292,0.17-0.292,0.446,0.004,0.616l2.707,1.564c0.295,0.17,0.772,0.17,1.064,0l1.591-0.924 c0.293-0.171,0.293-0.448-0.003-0.619L239.186,287.783z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7A7A7"
    },
    d: "M254.665,283.043c0.294,0.169,0.296,0.445,0.004,0.616l-14.249,8.28 c-0.292,0.169-0.769,0.169-1.064,0l-44.701-25.809c-0.294-0.17-0.296-0.447-0.004-0.617l14.249-8.28 c0.293-0.17,0.77-0.17,1.064,0L254.665,283.043z M210.07,273.432c-0.293,0.17-0.291,0.445,0.004,0.616l17.516,10.114 c0.295,0.17,0.771,0.17,1.064,0l1.591-0.925c0.292-0.17,0.291-0.447-0.003-0.616l-17.517-10.114 c-0.295-0.17-0.771-0.17-1.065,0L210.07,273.432 M196.467,265.578c-0.293,0.17-0.29,0.446,0.004,0.616l4.661,2.692 c0.294,0.17,0.771,0.17,1.064,0l1.593-0.925c0.292-0.17,0.292-0.447-0.003-0.617l-4.661-2.69c-0.295-0.17-0.772-0.17-1.064,0 L196.467,265.578 M200.119,263.455c-0.294,0.17-0.291,0.447,0.002,0.617l3.976,2.295c0.294,0.17,0.771,0.17,1.064,0 l1.592-0.925c0.292-0.169,0.291-0.445-0.004-0.616l-3.975-2.294c-0.295-0.17-0.771-0.171-1.064,0L200.119,263.455  M203.771,261.333c-0.294,0.17-0.291,0.447,0.002,0.617l3.976,2.295c0.294,0.169,0.771,0.169,1.064-0.001l1.592-0.925 c0.293-0.17,0.291-0.446-0.003-0.617l-3.976-2.294c-0.294-0.17-0.77-0.17-1.063,0L203.771,261.333 M243.832,284.463 c-0.293,0.17-0.292,0.446,0.004,0.617l2.708,1.563c0.295,0.169,0.771,0.169,1.064-0.001l1.591-0.924 c0.293-0.171,0.292-0.447-0.003-0.618l-2.707-1.563c-0.296-0.171-0.771-0.171-1.065,0L243.832,284.463 M240.18,286.585 c-0.292,0.17-0.292,0.446,0.004,0.617l2.708,1.563c0.295,0.17,0.772,0.17,1.064,0l1.591-0.924 c0.294-0.172,0.292-0.447-0.003-0.617l-2.708-1.564c-0.295-0.17-0.771-0.17-1.065,0L240.18,286.585 M236.529,288.707 c-0.292,0.17-0.292,0.446,0.004,0.616l2.707,1.564c0.295,0.17,0.772,0.17,1.064,0l1.591-0.924 c0.293-0.171,0.293-0.448-0.003-0.619l-2.707-1.562c-0.296-0.171-0.772-0.17-1.065,0L236.529,288.707 M228.837,269.732 c0.292-0.17,0.291-0.447-0.003-0.618l-1.602-0.924c-0.295-0.169-0.771-0.169-1.065,0l-1.591,0.924 c-0.292,0.171-0.291,0.447,0.004,0.618l1.602,0.924c0.295,0.171,0.771,0.171,1.065,0L228.837,269.732 M239.129,275.674 c0.292-0.17,0.292-0.446-0.004-0.617l-1.602-0.925c-0.294-0.17-0.771-0.17-1.065,0l-1.59,0.925 c-0.294,0.17-0.291,0.446,0.003,0.617l1.602,0.925c0.295,0.17,0.772,0.17,1.064,0L239.129,275.674 M232.268,271.712 c0.293-0.171,0.292-0.447-0.003-0.617l-1.602-0.923c-0.295-0.171-0.772-0.171-1.065,0l-1.591,0.923 c-0.294,0.17-0.292,0.446,0.003,0.617l1.602,0.924c0.294,0.171,0.771,0.171,1.065,0L232.268,271.712 M244.398,280.559 l1.592-0.924c0.293-0.169,0.292-0.445-0.003-0.616l-1.602-0.925c-0.295-0.17-0.773-0.17-1.065,0l-1.591,0.925 c-0.294,0.171-0.292,0.447,0.003,0.616l1.602,0.924C243.63,280.73,244.106,280.73,244.398,280.559 M247.829,282.542 l1.591-0.925c0.292-0.17,0.292-0.447-0.003-0.617l-1.602-0.925c-0.295-0.17-0.772-0.17-1.064,0l-1.592,0.925 c-0.293,0.17-0.291,0.447,0.004,0.617l1.602,0.925C247.059,282.71,247.537,282.71,247.829,282.542 M221.975,265.771 c0.294-0.17,0.292-0.446-0.003-0.617l-1.602-0.926c-0.294-0.17-0.772-0.169-1.065,0.001l-1.591,0.925 c-0.294,0.171-0.292,0.446,0.003,0.616l1.603,0.925c0.294,0.17,0.771,0.17,1.064,0L221.975,265.771 M240.968,278.579 l1.591-0.925c0.294-0.169,0.292-0.446-0.003-0.616l-1.602-0.925c-0.294-0.17-0.772-0.169-1.064,0l-1.591,0.925 c-0.293,0.17-0.292,0.445,0.004,0.616l1.602,0.925C240.199,278.75,240.674,278.75,240.968,278.579 M235.698,273.693 c0.292-0.17,0.292-0.447-0.003-0.617l-1.602-0.925c-0.295-0.171-0.773-0.169-1.065,0l-1.591,0.925 c-0.293,0.171-0.292,0.446,0.003,0.617l1.602,0.924c0.295,0.17,0.772,0.17,1.065,0L235.698,273.693 M207.422,259.211 c-0.293,0.171-0.291,0.447,0.003,0.617l1.602,0.925c0.294,0.171,0.771,0.171,1.064,0l1.591-0.925 c0.293-0.169,0.292-0.445-0.002-0.616l-1.603-0.925c-0.293-0.17-0.771-0.17-1.064,0L207.422,259.211 M209.348,269.399 l1.602,0.925c0.295,0.17,0.771,0.17,1.065,0l1.591-0.925c0.293-0.17,0.292-0.447-0.004-0.617L212,267.857 c-0.295-0.17-0.772-0.17-1.064,0l-1.591,0.925C209.051,268.952,209.052,269.228,209.348,269.399 M205.917,266.804 c-0.293,0.17-0.292,0.446,0.003,0.616l1.602,0.925c0.295,0.17,0.772,0.17,1.065,0l1.591-0.925 c0.293-0.17,0.292-0.446-0.004-0.617l-1.602-0.924c-0.295-0.171-0.771-0.171-1.064,0L205.917,266.804 M209.569,264.682 c-0.293,0.171-0.292,0.447,0.002,0.617l1.603,0.924c0.296,0.171,0.771,0.171,1.065,0l1.59-0.924 c0.294-0.17,0.293-0.446-0.003-0.617l-1.601-0.924c-0.296-0.171-0.772-0.171-1.065,0L209.569,264.682 M214.587,265.736 l-1.592,0.924c-0.294,0.171-0.292,0.447,0.003,0.617l1.602,0.925c0.294,0.17,0.771,0.17,1.065,0l1.591-0.925 c0.293-0.171,0.292-0.445-0.004-0.617l-1.601-0.924C215.357,265.564,214.88,265.564,214.587,265.736 M217.788,271.814 l-1.592,0.925c-0.292,0.17-0.29,0.446,0.004,0.617l1.602,0.925c0.295,0.17,0.771,0.17,1.064,0l1.592-0.925 c0.293-0.17,0.292-0.446-0.003-0.617l-1.602-0.925C218.557,271.643,218.081,271.643,217.788,271.814 M221.44,269.692 l-1.592,0.924c-0.293,0.17-0.291,0.446,0.003,0.618l1.601,0.924c0.296,0.17,0.771,0.17,1.065,0l1.591-0.924 c0.293-0.171,0.292-0.447-0.003-0.618l-1.602-0.924C222.208,269.521,221.732,269.521,221.44,269.692 M231.719,275.626 l-1.592,0.925c-0.293,0.17-0.291,0.446,0.003,0.617l1.602,0.924c0.295,0.171,0.771,0.171,1.064,0l1.591-0.924 c0.294-0.171,0.292-0.447-0.004-0.617l-1.601-0.925C232.488,275.456,232.012,275.456,231.719,275.626 M228.066,277.749 l-1.59,0.924c-0.293,0.171-0.293,0.446,0.003,0.618l1.601,0.924c0.295,0.171,0.773,0.171,1.065,0l1.591-0.924 c0.293-0.171,0.292-0.447-0.004-0.618l-1.601-0.924C228.836,277.578,228.359,277.578,228.066,277.749 M243.062,281.56 c-0.295-0.17-0.773-0.17-1.064,0l-1.591,0.925c-0.294,0.17-0.292,0.446,0.002,0.617l1.603,0.925 c0.294,0.17,0.771,0.17,1.064,0l1.591-0.925c0.294-0.17,0.292-0.447-0.003-0.617L243.062,281.56 M241.015,285.225 c0.294-0.171,0.292-0.447-0.004-0.618l-1.601-0.924c-0.295-0.171-0.773-0.171-1.064,0l-1.591,0.924 c-0.293,0.17-0.292,0.446,0.004,0.618l1.601,0.924c0.294,0.17,0.772,0.169,1.064,0L241.015,285.225 M239.635,279.582 c-0.295-0.169-0.77-0.169-1.064,0.001l-1.591,0.925c-0.293,0.171-0.292,0.446,0.003,0.617l1.602,0.924 c0.295,0.17,0.771,0.171,1.066,0l1.591-0.923c0.293-0.171,0.291-0.448-0.004-0.618L239.635,279.582 M235.999,284.171 l1.591-0.925c0.293-0.171,0.29-0.447-0.004-0.617l-1.603-0.924c-0.294-0.171-0.771-0.171-1.064,0l-1.591,0.924 c-0.292,0.17-0.292,0.446,0.002,0.617l1.603,0.925C235.228,284.341,235.705,284.341,235.999,284.171 M235.145,277.604 l-1.591,0.925c-0.295,0.17-0.292,0.445,0.003,0.617l1.601,0.924c0.296,0.171,0.772,0.171,1.066,0l1.591-0.924 c0.293-0.171,0.292-0.447-0.004-0.617l-1.601-0.925C235.914,277.434,235.439,277.434,235.145,277.604 M232.572,282.192 l1.591-0.924c0.293-0.171,0.292-0.446-0.004-0.617l-1.602-0.924c-0.295-0.171-0.771-0.171-1.064,0l-1.591,0.924 c-0.293,0.17-0.292,0.446,0.002,0.617l1.602,0.924C231.802,282.363,232.279,282.362,232.572,282.192 M221.214,273.792 l-1.591,0.925c-0.293,0.17-0.293,0.446,0.003,0.616l1.602,0.924c0.294,0.171,0.772,0.171,1.064,0l1.592-0.924 c0.294-0.17,0.292-0.446-0.003-0.616l-1.602-0.925C221.984,273.621,221.507,273.621,221.214,273.792 M224.866,271.67 l-1.592,0.924c-0.294,0.17-0.292,0.447,0.004,0.617l1.602,0.924c0.294,0.171,0.771,0.171,1.064,0l1.591-0.924 c0.294-0.171,0.292-0.447-0.003-0.617l-1.602-0.924C225.636,271.499,225.159,271.499,224.866,271.67 M252.851,283.597 c0.292-0.17,0.292-0.447-0.003-0.617l-1.601-0.925c-0.295-0.171-0.772-0.171-1.065,0l-1.591,0.925 c-0.293,0.17-0.292,0.446,0.004,0.617l1.601,0.925c0.295,0.17,0.771,0.17,1.065,0L252.851,283.597 M206.555,271.402 c-0.293,0.17-0.291,0.446,0.004,0.616l1.602,0.925c0.295,0.17,0.772,0.17,1.065,0l1.591-0.925 c0.293-0.17,0.292-0.446-0.003-0.616l-1.602-0.924c-0.295-0.17-0.772-0.17-1.066,0L206.555,271.402 M203.041,269.374 c-0.294,0.17-0.292,0.446,0.005,0.616l1.601,0.924c0.294,0.171,0.771,0.171,1.064,0.001l1.591-0.926 c0.292-0.169,0.292-0.446-0.003-0.616l-1.602-0.925c-0.295-0.17-0.772-0.17-1.064,0L203.041,269.374 M229.5,284.649 c-0.293,0.17-0.292,0.446,0.004,0.616l1.601,0.924c0.295,0.171,0.771,0.171,1.064,0l1.592-0.925 c0.292-0.17,0.292-0.446-0.004-0.616l-1.602-0.925c-0.295-0.17-0.773-0.17-1.065,0L229.5,284.649 M218.544,263.79 c0.293-0.171,0.292-0.447-0.002-0.617l-1.602-0.925c-0.295-0.17-0.771-0.17-1.065,0l-1.591,0.925 c-0.293,0.171-0.292,0.446,0.002,0.617l1.603,0.924c0.295,0.17,0.77,0.17,1.064,0L218.544,263.79 M215.113,261.81 c0.293-0.171,0.292-0.447-0.002-0.617l-1.603-0.925c-0.294-0.171-0.771-0.17-1.063,0.001l-1.591,0.924 c-0.294,0.17-0.293,0.446,0.003,0.617l1.602,0.924c0.295,0.17,0.771,0.17,1.064,0L215.113,261.81 M225.405,267.75 c0.292-0.17,0.292-0.446-0.002-0.616l-1.602-0.925c-0.294-0.169-0.772-0.168-1.064,0.001l-1.592,0.924 c-0.293,0.17-0.292,0.446,0.004,0.616l1.602,0.926c0.294,0.169,0.77,0.169,1.064,0L225.405,267.75 M228.292,273.648 l-1.591,0.925c-0.292,0.17-0.292,0.446,0.004,0.616l1.602,0.924c0.295,0.171,0.771,0.171,1.064,0l1.591-0.924 c0.293-0.17,0.291-0.447-0.003-0.616l-1.602-0.926C229.062,273.477,228.586,273.477,228.292,273.648 M224.641,275.77 l-1.592,0.925c-0.292,0.17-0.292,0.446,0.003,0.616l1.602,0.924c0.295,0.17,0.772,0.17,1.065,0l1.591-0.924 c0.294-0.171,0.292-0.447-0.002-0.616l-1.603-0.925C225.41,275.6,224.934,275.6,224.641,275.77 M233.014,286.679 c-0.293,0.17-0.291,0.446,0.003,0.616l1.603,0.926c0.294,0.17,0.771,0.17,1.063,0l1.591-0.926 c0.293-0.169,0.292-0.445-0.003-0.616l-1.602-0.924c-0.295-0.17-0.771-0.17-1.065,0L233.014,286.679 M212.773,271.377 l1.602,0.925c0.295,0.17,0.772,0.17,1.065,0l1.591-0.925c0.293-0.17,0.292-0.446-0.003-0.616l-1.603-0.926 c-0.294-0.17-0.77-0.17-1.064,0l-1.591,0.926C212.478,270.931,212.48,271.207,212.773,271.377 M218.013,267.714l-1.59,0.925 c-0.294,0.17-0.292,0.446,0.002,0.616l1.602,0.925c0.294,0.169,0.77,0.169,1.064-0.001l1.591-0.924 c0.292-0.171,0.291-0.447-0.003-0.616l-1.603-0.925C218.784,267.543,218.307,267.543,218.013,267.714"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M225.93,271.67c-0.294-0.171-0.771-0.171-1.064,0l-1.592,0.924 c-0.294,0.17-0.292,0.446,0.004,0.617l1.602,0.924c0.294,0.171,0.771,0.171,1.064,0l1.591-0.924 c0.294-0.171,0.292-0.447-0.003-0.617L225.93,271.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M229.131,277.749c-0.295-0.171-0.772-0.171-1.065,0l-1.591,0.924 c-0.293,0.171-0.292,0.446,0.003,0.618l1.601,0.924c0.295,0.171,0.773,0.171,1.065,0l1.591-0.924 c0.293-0.171,0.292-0.447-0.004-0.618L229.131,277.749z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M232.558,279.727c-0.295-0.171-0.771-0.171-1.064,0l-1.591,0.924 c-0.293,0.17-0.292,0.446,0.002,0.617l1.602,0.924c0.295,0.17,0.773,0.17,1.065,0l1.591-0.924 c0.293-0.171,0.292-0.446-0.004-0.617L232.558,279.727z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M212.727,272.507c-0.295-0.17-0.771-0.17-1.065,0l-1.591,0.925 c-0.293,0.17-0.291,0.445,0.004,0.616l17.516,10.114c0.295,0.17,0.771,0.17,1.064,0l1.591-0.925 c0.292-0.17,0.291-0.447-0.003-0.616L212.727,272.507z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M206.425,260.409c-0.294-0.17-0.77-0.17-1.063,0l-1.592,0.925 c-0.293,0.17-0.29,0.447,0.003,0.617l3.976,2.295c0.294,0.169,0.771,0.169,1.064-0.001l1.592-0.925 c0.293-0.17,0.291-0.446-0.003-0.617L206.425,260.409z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M223.801,266.209c-0.294-0.169-0.772-0.168-1.064,0.001l-1.592,0.924 c-0.293,0.17-0.292,0.446,0.004,0.616l1.602,0.926c0.294,0.169,0.77,0.169,1.064,0l1.591-0.926 c0.292-0.17,0.292-0.446-0.002-0.616L223.801,266.209z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343"
    },
    d: "M239.41,283.683c-0.295-0.171-0.772-0.171-1.064,0l-1.591,0.924 c-0.293,0.17-0.292,0.446,0.004,0.618l1.602,0.924c0.294,0.17,0.772,0.169,1.064,0l1.592-0.924 c0.294-0.171,0.292-0.447-0.004-0.618L239.41,283.683z"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000173151784254291703290000011979394574978353537_",
    style: {
      enableBackground: "new"
    },
    d: "M188.591,228.92 c-0.455,0.265-0.909,0.528-1.363,0.794c0.097-0.057,0.232-0.048,0.38,0.037l1.364-0.793 C188.823,228.872,188.688,228.865,188.591,228.92z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140721658098117856670000003053273745417189552_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173151784254291703290000011979394574978353537_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000140721658098117856670000003053273745417189552_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3C3C"
    },
    d: "M187.607,229.751l1.364-0.793c-0.057-0.032-0.112-0.054-0.163-0.065l-1.364,0.793 C187.496,229.696,187.55,229.718,187.607,229.751"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373737"
    },
    d: "M187.445,229.686l1.364-0.793c-0.034-0.007-0.067-0.009-0.099-0.007l-1.364,0.793 C187.378,229.676,187.411,229.679,187.445,229.686"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M187.347,229.679l1.364-0.793c-0.025,0.001-0.052,0.007-0.076,0.015l-1.364,0.793 C187.294,229.685,187.32,229.68,187.347,229.679"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030"
    },
    d: "M187.271,229.694l1.364-0.793c-0.016,0.006-0.03,0.012-0.044,0.02l-1.363,0.794 C187.241,229.705,187.255,229.699,187.271,229.694"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000007422283931249579870000005852692072460403606_",
    style: {
      enableBackground: "new"
    },
    d: "M239.902,298.393 c0.454-0.265,0.909-0.529,1.364-0.794c0.096-0.055,0.155-0.173,0.155-0.343l-1.364,0.793 C240.058,298.218,239.998,298.336,239.902,298.393z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140714163550300322740000004327590253687200179_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007422283931249579870000005852692072460403606_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000140714163550300322740000004327590253687200179_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272727"
    },
    d: "M239.902,298.393l1.364-0.794c0.096-0.055,0.155-0.173,0.155-0.343l-1.364,0.793 C240.058,298.218,239.998,298.336,239.902,298.393"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5ACAE"
    },
    d: "M247.174,172.119c0,0,1.404,18.873,3.505,20.369c2.099,1.492,12.263-0.503,12.263-6.978 c0-6.47-0.843-15.006-0.843-15.006L247.174,172.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2C0"
    },
    d: "M235.107,144.594c0,0-1.726,37.898,10.531,39.712c9.204,1.364,21.171-6.248,21.571-18.745 c0.406-12.496,4.96-27.498-3.717-27.52C254.813,138.023,234.101,136.164,235.107,144.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434D88"
    },
    d: "M273.891,144.799c0,0,1.954,14.737-2.664,20.417c-4.615,5.681-9.586,0.888-9.409-1.598 c0.177-2.485,0-7.279,0.533-12.25C262.882,146.398,273.181,141.603,273.891,144.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2C0"
    },
    d: "M261.634,163.79c0,0,6.351-7.637,7.81-2.259c1.46,5.375-2.868,9.705-5.607,8.948 C261.1,169.722,261.634,163.79,261.634,163.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2C0"
    },
    d: "M265.083,161.52c0,0,2.244-5.744,5.575-2.983c3.337,2.757,0.528,12.365-3.577,10.374 C262.976,166.912,265.083,161.52,265.083,161.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434D88"
    },
    d: "M251.319,130.83c0,0-13.686-0.956-16.351,7.753c-4.752,15.529,5.17,20.498,9.427,22.618 c4.257,2.12,15.473,1.264,20.322-3.308c4.85-4.566,12.905-8.963,7.551-20.505C266.909,125.852,251.319,130.83,251.319,130.83z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2C0"
    },
    d: "M240.07,267.65c-3.95-3.951,10.214-10.886,9.697-11.852c-0.519-0.962-6.263,3.662-7.183,1.795 c-0.921-1.871,2.155-4.31,5.746-5.747c3.59-1.437,3.411-0.167,7.273-0.497c2.63-0.226,18.608-10.361,19.966-10.973l-3.871-13.639 l16.583-3.636c0,0,3.555,20.771,2.101,23.622c-0.633,1.243-3.707,3.913-5.848,5.253c-2.141,1.342-15.638,6.192-18.247,7.053 c-3.406,1.125-6.106,7.182-12.57,10.056C247.253,271.96,244.02,271.601,240.07,267.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC3990"
    },
    d: "M282.205,199.483c-3.393-3.701-10.97-4.372-13.492,3.379c-2.517,7.75-0.496,25.759,2.779,26.869 c2.115,0.723,7.412-0.646,11.161-1.426c4.573-0.956,6.275-3.504,7.18-5.202C291.25,220.447,287.941,205.746,282.205,199.483z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E4E4E"
    },
    points: "240.058,298.049 241.421,297.256 241.528,259.916 240.164,260.709  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#686868"
    },
    points: "239.631,259.788 240.996,258.995 188.972,228.958 187.607,229.751  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000127009054464875240840000016767038498346430391_",
    style: {
      enableBackground: "new"
    },
    d: "M240.164,260.709 l1.364-0.793c0.001-0.338-0.237-0.751-0.532-0.921l-1.365,0.793C239.926,259.957,240.164,260.37,240.164,260.709z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078758788511728853350000016253121688787881884_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127009054464875240840000016767038498346430391_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000078758788511728853350000016253121688787881884_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F4F4F"
    },
    d: "M240.164,260.709l1.364-0.793c0-0.068-0.01-0.139-0.027-0.211l-1.364,0.793 C240.153,260.57,240.164,260.641,240.164,260.709"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353"
    },
    d: "M240.136,260.498l1.364-0.793c-0.011-0.046-0.026-0.089-0.042-0.134l-1.364,0.793 C240.111,260.408,240.125,260.453,240.136,260.498"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#585858"
    },
    d: "M240.094,260.364l1.364-0.793c-0.015-0.04-0.033-0.079-0.052-0.117l-1.364,0.792 C240.061,260.285,240.079,260.324,240.094,260.364"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5B5B"
    },
    d: "M240.042,260.247l1.364-0.792c-0.02-0.039-0.041-0.077-0.063-0.114l-1.366,0.793 C240.001,260.17,240.023,260.208,240.042,260.247"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F5F5F"
    },
    d: "M239.977,260.134l1.366-0.793c-0.028-0.042-0.058-0.082-0.089-0.12l-1.364,0.792 C239.922,260.051,239.95,260.092,239.977,260.134"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464"
    },
    d: "M239.89,260.013l1.364-0.792c-0.076-0.093-0.164-0.172-0.258-0.226l-1.365,0.793 C239.726,259.841,239.814,259.92,239.89,260.013"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393939"
    },
    d: "M187.607,229.751c-0.296-0.17-0.535-0.034-0.537,0.305l-0.105,37.34 c0,0.339,0.237,0.751,0.532,0.922l52.024,30.037c0.295,0.17,0.535,0.033,0.536-0.307l0.106-37.34 c0-0.339-0.237-0.751-0.533-0.921L187.607,229.751z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047740423073394577470000002715948026576118198_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.086,
    y1: 375.3513,
    x2: 393.6083,
    y2: 179.368,
    gradientTransform: "matrix(0.9975 -0.0708 0.0708 0.9975 -21.2383 27.5969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB5E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF98B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047740423073394577470000002715948026576118198_)"
    },
    d: "M378.358,217.698 c-7.086,16.304-17.754,16.031-21.705,23.267c-3.952,7.236-7.63,18.318-6.538,33.698c2.185,30.759,13.117,39.601,4.616,55.317 c-8.501,15.718-18.37,31.532-16.764,44.471c1.606,12.938,1.554,21.873,1.554,21.873s3.518-8.494,27.349-21.178 c23.831-12.684,36.142-32.794,32.048-51.739c-4.093-18.944-12.486-30.714-1.493-50.044c10.993-19.329,13.646-59.363,5.398-69.082 C394.576,194.562,385.444,201.393,378.358,217.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE77B3"
    },
    d: "M386.569,238.586c-8.174,2.61-11.629,14.377-13.548,21.755 c-3.557,13.68-2.668,28.407-1.743,42.355c0.934,14.07,2.97,28.7-3.247,41.908c-5.642,11.986-17.954,20.084-21.525,33.19 c-0.208,0.764,0.858,0.997,1.222,0.415c6.729-10.751,15.839-19.822,22.226-30.745c6.095-10.423,5.721-23.278,4.932-34.891 c-0.939-13.823-2.393-27.672-1.179-41.527c0.535-6.098,1.79-12.153,3.984-17.871c1.886-4.92,4.465-11.079,9.354-13.652 C387.595,239.234,387.12,238.41,386.569,238.586z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019674287355777907030000015907978836217363875_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.9878,
    y1: 395.0516,
    x2: 416.515,
    y2: 228.0849,
    gradientTransform: "matrix(0.9963 -0.0858 0.0858 0.9963 -27.3677 35.5162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F0A1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF97B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019674287355777907030000015907978836217363875_)"
    },
    d: "M407.076,270.41 c0,0-1.532,25.77-11.282,35.989c-9.75,10.22-20.013,21.734-23.976,48.338c-3.962,26.605-21.727,38.14-31.498,40.858 c0,0,25.918,17.777,51.325,0.581c25.408-17.195,17.169-40.248,21.686-53.143c4.517-12.896,24.732-17.764,33.948-34.19 c9.216-16.427,4.146-53.509-6.834-57.565C429.465,247.221,412.246,250.58,407.076,270.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB75CA"
    },
    d: "M428.247,281.473c-2.459,6.022-4.377,12.242-6.903,18.243 c-2.923,6.949-7.772,12.092-12.658,17.679c-8.278,9.467-11.961,19.941-14.046,32.159c-2.011,11.78-3.955,23.565-12.15,32.81 c-4.458,5.027-10.661,8.286-16.98,10.303c-3.308,1.055-6.835,1.478-10.272,1.878c-2.215,0.258-3.669,0.058-5.203,1.739 c-0.325,0.356,0.096,0.98,0.548,0.779c2.714-1.208,6.693-0.608,9.646-0.948c3.037-0.349,6.023-1.192,8.899-2.197 c4.91-1.713,9.731-4.579,13.464-8.207c8.359-8.125,11.458-18.78,13.53-29.936c1.119-6.027,1.956-12.085,3.651-17.989 c2.187-7.617,6.691-14.044,11.837-19.95c4.328-4.966,8.463-9.552,11.285-15.556c3.031-6.448,5.021-13.516,6.26-20.513 C429.249,281.239,428.457,280.958,428.247,281.473z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M260.104,465.463c-0.432,0.443-0.803,0.932-1.108,1.453l-0.465-0.24 c-0.068-0.297-0.35-0.502-0.66-0.467c-0.33,0.039-0.566,0.34-0.529,0.67c0.039,0.332,0.34,0.568,0.67,0.529 c0.066-0.006,0.127-0.025,0.184-0.051l0.451,0.234c-0.25,0.553-0.432,1.139-0.539,1.742l0.748,0.133 c0.228-1.307,0.85-2.508,1.791-3.475L260.104,465.463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M262.596,464.594c0.936-0.447,1.941-0.674,2.996-0.674c0.496,0,0.992,0.053,1.475,0.158l0.16-0.742 c-0.535-0.115-1.084-0.174-1.635-0.174c-0.172,0-0.342,0.006-0.51,0.016l-0.074-0.625c0.188-0.15,0.297-0.389,0.266-0.645 c-0.045-0.393-0.402-0.674-0.795-0.629c-0.393,0.047-0.674,0.402-0.627,0.797c0.029,0.254,0.19,0.461,0.404,0.563l0.072,0.625 c-0.713,0.115-1.402,0.332-2.059,0.645L262.596,464.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M272.047,464.512c-0.309,0.037-0.535,0.303-0.529,0.607l-0.416,0.363 c-0.418-0.43-0.891-0.813-1.408-1.139l-0.404,0.641c1.135,0.715,2.022,1.727,2.565,2.926l0.689-0.313 c-0.25-0.553-0.566-1.072-0.941-1.545l0.402-0.352c0.06,0.012,0.125,0.016,0.189,0.008c0.332-0.041,0.566-0.342,0.525-0.672 C272.68,464.706,272.379,464.471,272.047,464.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M265.045,473.372c-0.387,0.023-0.775,0.035-1.158,0.035c-0.879,0-1.733-0.06-2.479-0.18 c-0.391-0.063-0.846-0.154-1.27-0.293c1.047,1.861,3.068,3.125,5.389,3.125c2.855,0,5.262-1.916,5.949-4.502 c-0.682,0.449-1.506,0.824-2.459,1.121C267.838,473.048,266.463,473.286,265.045,473.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M265.592,464.678c-3.352,0-6.08,2.668-6.08,5.945c0,0.424,0.047,0.848,0.137,1.26 c0.674,0.484,2.707,0.891,5.348,0.732c2.881-0.174,5.297-0.959,6.672-2.161c-0.004-0.193-0.02-0.389-0.045-0.58 C271.244,466.913,268.65,464.678,265.592,464.678z M263.432,471.194c-1.02,0-1.85-0.83-1.85-1.85c0-1.02,0.83-1.85,1.85-1.85 s1.85,0.83,1.85,1.85C265.281,470.364,264.451,471.194,263.432,471.194z M268.17,470.286c-0.75,0-1.361-0.609-1.361-1.359 s0.611-1.361,1.361-1.361s1.359,0.611,1.359,1.361S268.92,470.286,268.17,470.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M279.369,467.315c0-0.666,0.293-0.938,0.844-1.008c0.576-0.07,1.088,0.123,1.383,0.238v-1.729 c-0.434-0.186-0.947-0.307-1.59-0.307c-1.674,0-2.568,1.102-2.568,2.783v0.889h-1.34v1.717h1.34v5.456h1.932v-5.456h2.228v-1.717 h-2.228V467.315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M286.223,467.989c-0.881,0-1.568,0.305-2.02,0.977v-0.783h-1.873v7.172h1.932v-3.909 c0-1.066,0.615-1.613,1.51-1.613c0.168,0,0.35,0.016,0.525,0.045l1.021-1.551C287.07,468.118,286.637,467.989,286.223,467.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M290.479,467.989c-2.147,0-3.627,1.539-3.627,3.797c0,2.258,1.525,3.754,3.725,3.754 c1.205,0,2.242-0.342,3.057-1.09l-1.133-1.242c-0.52,0.435-1.191,0.688-1.814,0.688c-0.91,0-1.635-0.451-1.842-1.486h5.084 c0.022-0.164,0.037-0.43,0.037-0.652C293.957,469.522,292.543,467.989,290.479,467.989z M288.852,471.09 c0.17-0.889,0.703-1.436,1.613-1.436c0.828,0,1.383,0.518,1.56,1.436H288.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M298.133,467.989c-2.147,0-3.627,1.539-3.627,3.797c0,2.258,1.523,3.754,3.723,3.754 c1.207,0,2.242-0.342,3.057-1.09l-1.133-1.242c-0.518,0.435-1.191,0.688-1.813,0.688c-0.91,0-1.637-0.451-1.844-1.486h5.086 c0.022-0.164,0.037-0.43,0.037-0.652C301.611,469.522,300.197,467.989,298.133,467.989z M296.504,471.09 c0.17-0.889,0.703-1.436,1.613-1.436c0.828,0,1.385,0.518,1.563,1.436H296.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M306.484,467.989c-0.984,0-1.672,0.4-2.139,0.984v-0.791h-1.887v10.133h1.924v-3.709 c0.467,0.555,1.148,0.934,2.109,0.934c1.977,0,3.473-1.621,3.473-3.775C309.965,469.61,308.469,467.989,306.484,467.989z  M306.131,473.741c-1.096,0-1.844-0.844-1.844-1.977c0-1.133,0.748-1.977,1.844-1.977c1.139,0,1.85,0.881,1.85,1.977 C307.98,472.86,307.27,473.741,306.131,473.741z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.877,
    y: 468.182,
    style: {
      fill: "#1D262D"
    },
    width: 1.932,
    height: 7.172
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M311.832,464.59c-0.697,0-1.228,0.549-1.228,1.244c0,0.695,0.531,1.23,1.228,1.23 c0.695,0,1.236-0.535,1.236-1.23C313.068,465.139,312.527,464.59,311.832,464.59z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D262D"
    },
    points: "317.623,471.558 321.102,468.182 318.734,468.182 316.031,470.735 316.031,464.694  314.1,464.694 314.1,475.354 316.031,475.354 316.031,472.452 318.748,475.354 321.125,475.354  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M184.412,469.284c-0.57-0.777-1.435-1.246-2.387-1.246c-1.86,0-3.149,1.465-3.149,3.721 c0,2.301,1.304,3.707,3.149,3.707c0.996,0,1.859-0.514,2.387-1.23v1.055h1.1v-9.772h-1.1V469.284z M184.412,473.37 c-0.395,0.615-1.244,1.113-2.124,1.113c-1.42,0-2.27-1.156-2.27-2.725c0-1.567,0.85-2.739,2.27-2.739 c0.88,0,1.73,0.527,2.124,1.143V473.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M190.417,468.038c-2.021,0-3.486,1.656-3.486,3.707c0,2.211,1.509,3.721,3.604,3.721 c1.157,0,2.109-0.381,2.813-1.084l-0.527-0.719c-0.557,0.572-1.377,0.895-2.183,0.895c-1.523,0-2.461-1.113-2.549-2.447h5.728 v-0.277C193.816,469.707,192.556,468.038,190.417,468.038z M188.088,471.305c0.059-1.084,0.806-2.359,2.314-2.359 c1.611,0,2.314,1.305,2.329,2.359H188.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M195.867,470.045c0-0.631,0.601-1.113,1.566-1.113c0.909,0,1.686,0.381,2.109,0.893l0.514-0.762 c-0.571-0.57-1.421-1.025-2.623-1.025c-1.685,0-2.636,0.938-2.636,2.037c0,2.622,4.38,1.567,4.38,3.282 c0,0.703-0.586,1.215-1.671,1.215c-0.966,0-1.859-0.469-2.328-1.01l-0.571,0.791c0.718,0.762,1.699,1.113,2.856,1.113 c1.831,0,2.782-0.953,2.782-2.139C200.246,470.573,195.867,471.599,195.867,470.045z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.667,
    y: 468.213,
    style: {
      fill: "#1D262D"
    },
    width: 1.1,
    height: 7.077
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M202.208,465.723c-0.395,0-0.731,0.336-0.731,0.746c0,0.41,0.337,0.734,0.731,0.734 c0.41,0,0.747-0.324,0.747-0.734C202.956,466.059,202.619,465.723,202.208,465.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M209.708,469.284c-0.571-0.777-1.421-1.246-2.373-1.246c-1.86,0-3.149,1.406-3.149,3.678 c0,2.285,1.304,3.662,3.149,3.662c0.996,0,1.86-0.543,2.373-1.26v1.01c0,1.553-1.099,2.125-2.27,2.125 c-1.011,0-1.714-0.264-2.3-0.967l-0.557,0.82c0.835,0.818,1.655,1.055,2.856,1.055c1.729,0,3.369-0.732,3.369-3.076v-6.871h-1.099 V469.284z M209.708,473.253c-0.381,0.615-1.23,1.158-2.109,1.158c-1.421,0-2.27-1.143-2.27-2.695c0-1.569,0.85-2.696,2.27-2.696 c0.879,0,1.729,0.527,2.109,1.143V473.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M216.255,468.038c-1.055,0-2.021,0.615-2.519,1.201v-1.025h-1.1v7.077h1.1v-5.172 c0.409-0.57,1.23-1.098,2.094-1.098c0.952,0,1.582,0.395,1.582,1.641v4.629h1.099v-4.967 C218.511,468.786,217.735,468.038,216.255,468.038z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M223.419,468.038c-2.021,0-3.486,1.656-3.486,3.707c0,2.211,1.509,3.721,3.604,3.721 c1.157,0,2.109-0.381,2.813-1.084l-0.527-0.719c-0.557,0.572-1.377,0.895-2.183,0.895c-1.523,0-2.461-1.113-2.549-2.447h5.727 v-0.277C226.817,469.707,225.557,468.038,223.419,468.038z M221.089,471.305c0.059-1.084,0.806-2.359,2.314-2.359 c1.611,0,2.314,1.305,2.329,2.359H221.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M233.35,469.284c-0.571-0.777-1.436-1.246-2.389-1.246c-1.86,0-3.148,1.465-3.148,3.721 c0,2.301,1.304,3.707,3.148,3.707c0.997,0,1.861-0.514,2.389-1.23v1.055h1.098v-9.772h-1.098V469.284z M233.35,473.37 c-0.396,0.615-1.245,1.113-2.124,1.113c-1.421,0-2.271-1.156-2.271-2.725c0-1.567,0.85-2.739,2.271-2.739 c0.879,0,1.728,0.527,2.124,1.143V473.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M243.178,468.038c-0.967,0-1.816,0.469-2.388,1.246v-3.766h-1.099v9.772h1.099v-1.055 c0.527,0.717,1.392,1.23,2.388,1.23c1.845,0,3.149-1.406,3.149-3.707C246.328,469.502,245.023,468.038,243.178,468.038z  M242.9,474.483c-0.864,0-1.729-0.498-2.109-1.113v-3.207c0.381-0.615,1.245-1.143,2.109-1.143c1.436,0,2.285,1.172,2.285,2.739 C245.185,473.327,244.335,474.483,242.9,474.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M250.238,474.015l-2.358-5.801h-1.186l2.959,7.149l-0.469,1.07 c-0.249,0.586-0.571,0.746-1.055,0.746c-0.175,0-0.439-0.043-0.601-0.117l-0.176,0.996c0.205,0.059,0.571,0.104,0.806,0.104 c0.938-0.016,1.655-0.412,2.08-1.436l3.546-8.512h-1.201L250.238,474.015z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP001);
export default __webpack_public_path__ + "static/media/p001.3fc70b726be63c3d099a676e93561868.svg";
export { ForwardRef as ReactComponent };